import axios from 'axios'
// 小白本地请求地址
// const SERVER_BASE_URL = 'http://test.nwn.com/admin/'
// 梦真
//const SERVER_BASE_URL = 'http://cuimengzhen.nwn.eoffcn.com/'
// 测试环境地址
//const SERVER_BASE_URL = 'http://beta.alitest.eoffcn.com/'
// 正式环境地址
// const SERVER_BASE_URL = 'https://nwn.eoffcn.com/'
const SERVER_BASE_URL = 'https://iip.eoffcn.com/'
// const SERVER_BASE_URL = 'https://iip.t.eoffcn.com/'


export {
  SERVER_BASE_URL
}
import 'mint-ui/lib/style.css'
import {Toast} from 'mint-ui'

console.log(process.env.NODE_ENV);
console.log(SERVER_BASE_URL);
let token = null
export default function fetch(options) {
  //token = 'test'
  return new Promise((resolve, reject) => {
    const instance = axios.create({
      baseURL: SERVER_BASE_URL,
      // headers: {
      //     'Authorization': token
      // },
      transformResponse: [function (data) {
      }]
    })
    instance.interceptors.request.use(
      config => {
        // Indicator.open({
        //     text: '加载中...',
        //     spinnerType: 'snake'
        // })
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
        return config
      },
      err => {
        return Promise.reject(err)
      })

    instance.interceptors.response.use(
      response => {
        // setTimeout(function () {
        //     Indicator.close()
        // }, 250)
        let res = response.request.response
        res = JSON.parse(res)
        if (res.retcode !== 0) {
          console.log(res.msg)
          //if (!options.customError) {
          //console.log(res.msg)
          // Toast({
          //     message: res.msg,
          //     className: 'offcn-toast'
          // });
          //}
          // return res
          // if(res.retcode == 1002){
          //     console.log('enter 1002')
          //     window.location.href = res.url;
          // }
        }
        // return Promise.resolve(response);
        return res
      },
      error => {
        //Indicator.close()
        // Toast({
        //     message: '网络不给力，请稍后重试',
        //     className: 'offcn-toast'
        // });
        // Toast(error.message || '网络出错啦，稍后再试~')
        console.log('网络不给力，请稍后重试')
        Toast('网络连接失败，请稍后重试')
        return Promise.reject(error) // 返回接口返回的错误信息
      })

    // 请求处理
    instance(options)
      .then((res) => {
        resolve(res)
        return false
      })
      .catch((error) => {
        reject(error)
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js